<div class="loading-shade" *ngIf="isLoadingResults">
	<mat-spinner [diameter]="50"></mat-spinner>
</div>
<form [formGroup]="form" *ngIf="form">
	<div [dir]="data.dir" class="row">
		<div class="col-sm-6 mb-2">
			<mat-label class="font-weight-bold field-required"
				>{{ "forms.common.Criteria.responseDecision" | translate }}
			</mat-label>
			<mat-form-field appearance="outline">
				<mat-select
					formControlName="responseDecision"
					[disabled]="data.viewOnly || (leaderDecisionValue == 'accept' && orginalResponseDecisionValue == 'accept')"
				>
					<mat-option *ngFor="let option of responses" [value]="option">
						{{ "forms.common.Criteria." + option | translate}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="col-sm-6 mb-2" *ngIf="disableLeaderDecision">
			<div
				class="form-custom-warning mt-warning"
				*ngIf="orginalResponseDecisionValue != responseDecisionValue && leaderDecisionValue == 'accept' && responseDecisionValue == 'accept'"
			>
				{{'forms.common.Criteria.Please note that you will not be able to modify the decision after saving' | translate}}
			</div>
		</div>

		<div class="col-sm-12 mb-2" *ngIf="responseDecisionValue && responseDecisionValue != 'accept'">
			<mat-label class="font-weight-bold field-required"
				>{{ "forms.common.Criteria.reasons" | translate }}
			</mat-label>
			<mat-form-field appearance="outline">
				<textarea
					matInput
					cdkAutosizeMinRows="3"
					cdkAutosizeMaxRows="3"
					formControlName="reasons"
					[disabled]="data.viewOnly || (leaderDecisionValue == 'accept' && orginalResponseDecisionValue == 'accept')"
				></textarea>
			</mat-form-field>
		</div>

		<div class="col-sm-12 mb-2" *ngIf="form.controls.responseDecision.value == 'accept_update'">
			<div class="d-flex justify-content-between align-items-baseline">
				<mat-label class="font-weight-bold field-required"
					>{{ "forms.common.Criteria.updates" | translate }}
				</mat-label>
				<button
					mat-icon-button
					matTooltip="{{ 'forms.common.Add' | translate }}"
					(click)="addUpdate()"
					*ngIf="!data.viewOnly && !(leaderDecisionValue == 'accept' && responseDecisionValue == 'accept')"
				>
					<mat-icon>add</mat-icon>
				</button>
			</div>
			<ng-container formArrayName="updates">
				<div class="d-flex" *ngFor="let control of updatesControls; let index = index">
					<mat-form-field appearance="outline">
						<textarea
							matInput
							cdkAutosizeMinRows="3"
							cdkAutosizeMaxRows="3"
							[formControl]="control"
							[disabled]="data.viewOnly || (leaderDecisionValue == 'accept' && orginalResponseDecisionValue == 'accept')"
						></textarea>
					</mat-form-field>
					<button
						mat-icon-button
						(click)="removeUpdate(index)"
						*ngIf="!data.viewOnly && !(leaderDecisionValue == 'accept' && responseDecisionValue == 'accept')"
					>
						<mat-icon color="warn">delete_forever</mat-icon>
					</button>
				</div>
			</ng-container>
		</div>

		<div
			class="col-sm-12 mb-2"
			*ngIf="responseDecisionValue && (responseDecisionValue == 'accept' || responseDecisionValue == 'accept_update')"
		>
			<app-masar-executive-plan
				[viewOnly]="data.viewOnly || (leaderDecisionValue == 'accept' && orginalResponseDecisionValue == 'accept')"
				[recommendationId]="recommendationId"
				(changeData)="changeExecutivePlan($event)"
			></app-masar-executive-plan>
		</div>

		<div
			class="col-sm-12 mt-2 d-flex justify-content-end"
			*ngIf="!data.viewOnly && disableLeaderDecision && !(leaderDecisionValue == 'accept' && orginalResponseDecisionValue == 'accept')"
		>
			<button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.viewOnly}">
				{{ "forms.common.cancel" | translate }}
			</button>
			<button
				*ngIf="!data.viewOnly"
				mat-flat-button
				(click)="save()"
				color="primary"
				[disabled]="form.invalid || (responseDecisionValue != 'reject' && !executivePlan?.length)"
			>
				{{ "forms.common.Criteria.save" | translate }}
			</button>
		</div>
	</div>
</form>

<form [formGroup]="leaderDecisionform" *ngIf="isLeaderDecision && leaderDecisionform">
	<div [dir]="data.dir" class="row">
		<div class="col-sm-6 mb-2">
			<mat-label class="font-weight-bold field-required"
				>{{ "forms.common.Criteria.Decision" | translate }}
			</mat-label>
			<mat-form-field appearance="outline">
				<mat-select formControlName="leaderDecision">
					<mat-option *ngFor="let option of leaderDecisions" [value]="option">
						{{ "forms.common.Criteria." + option | translate}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="col-sm-6 mb-2" *ngIf="!disableLeaderDecision">
			<div
				class="form-custom-warning mt-warning"
				*ngIf="leaderDecisionValue == 'accept' && responseDecisionValue == 'accept_update'"
			>
				{{'forms.common.Criteria.Please edit the recommendation summary' | translate}}
			</div>
			<div
				class="form-custom-warning mt-warning"
				*ngIf="leaderDecisionValue == 'accept' && responseDecisionValue == 'reject'"
			>
				{{'forms.common.Criteria.The recommendation summary will be deleted' | translate}}
			</div>
		</div>

		<div class="col-sm-12 mb-2" *ngIf="leaderDecisionValue && leaderDecisionValue == 'reject'">
			<mat-label class="font-weight-bold field-required"
				>{{ "forms.common.Criteria.reasons" | translate }}
			</mat-label>
			<mat-form-field appearance="outline">
				<textarea
					matInput
					cdkAutosizeMinRows="3"
					cdkAutosizeMaxRows="3"
					formControlName="leaderRejectReason"
				></textarea>
			</mat-form-field>
		</div>

		<div
			class="col-sm-12 mb-2"
			*ngIf="leaderDecisionValue && leaderDecisionValue == 'accept' && responseDecisionValue == 'accept_update'"
		>
			<mat-label class="font-weight-bold field-required"
				>{{ "forms.common.Criteria.summaryOfRecommendations" | translate }}
			</mat-label>
			<mat-form-field appearance="outline">
				<textarea
					matInput
					cdkAutosizeMinRows="3"
					cdkAutosizeMaxRows="3"
					formControlName="summaryText"
				></textarea>
			</mat-form-field>
		</div>

		<div
			class="col-sm-12 mt-2 d-flex justify-content-end"
			*ngIf="(leaderDecisionValue == 'accept' && orginalResponseDecisionValue == 'accept' && disableLeaderDecision);else showActions"
		>
			<button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.viewOnly}">
				{{ "forms.common.cancel" | translate }}
			</button>
		</div>
		<ng-template #showActions>
			<div class="col-sm-12 mt-2 d-flex justify-content-end" *ngIf="data.viewOnly">
				<button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.viewOnly}">
					{{ "forms.common.cancel" | translate }}
				</button>
				<button
					*ngIf="!disableLeaderDecision"
					mat-flat-button
					(click)="saveLeaderDecision()"
					color="primary"
					[disabled]="leaderDecisionform.invalid"
				>
					{{ "forms.common.Criteria.save" | translate }}
				</button>
			</div>
		</ng-template>
	</div>
</form>
